export default __webpack_public_path__ + "media/images/34-14c2af6817d1bc61ed1c2fe5744d53ec.png";